(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  const initializeFaqSidebar = (root) => {
    if (!root || root.dataset.faqInitialized === 'true') return;

    root.dataset.faqInitialized = 'true';

    const links = [...root.querySelectorAll('[data-faq-link]')];
    const groups = [...root.querySelectorAll('[data-faq-group]')];

    const activateLink = (groupId) => {
      links.forEach((link) => {
        const isActive = link.hash === `#${groupId}`;
        link.classList.toggle('is-active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'true');
          link.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = root.querySelector(link.hash);
        if (!target) return;

        event.preventDefault();
        activateLink(target.id);
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.history.replaceState(null, '', link.hash);
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visibleGroups = entries
            .filter((entry) => entry.isIntersecting)
            .sort((first, second) => Math.abs(first.boundingClientRect.top) - Math.abs(second.boundingClientRect.top));

          if (visibleGroups[0]) activateLink(visibleGroups[0].target.id);
        },
        { rootMargin: '-12% 0px -68% 0px', threshold: 0 }
      );

      groups.forEach((group) => observer.observe(group));
    }

    root.querySelectorAll('.faq-sidebar__item').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        root.querySelectorAll('.faq-sidebar__item[open]').forEach((openItem) => {
          if (openItem !== item) openItem.removeAttribute('open');
        });
      });
    });
  };

  document.querySelectorAll('[data-faq-sidebar]').forEach(initializeFaqSidebar);

  document.addEventListener('shopify:section:load', (event) => {
    initializeFaqSidebar(event.target.querySelector('[data-faq-sidebar]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recently-viewed-products')) {
    customElements.define(
      'recently-viewed-products',
      class RecentlyViewedProducts extends HTMLElement {
        connectedCallback() {
          const currentNode = this.querySelector('[data-recently-viewed-current]');
          const list = this.querySelector('[data-recently-viewed-list]');
          if (!currentNode || !list) return;

          let currentProduct;
          try {
            currentProduct = JSON.parse(currentNode.textContent);
          } catch (error) {
            return;
          }

          const history = this.readHistory();
          const previousProducts = history
            .filter((item) => item && item.handle !== currentProduct.handle)
            .slice(0, Number(this.dataset.limit) || 4);

          previousProducts.forEach((item) => {
            const card = this.createCard(item);
            if (card) list.append(card);
          });

          if (list.children.length > 0) this.hidden = false;
          this.stripInjectedWishlist();

          const updatedHistory = [currentProduct, ...history.filter((item) => item.handle !== currentProduct.handle)]
            .filter((item) => item && item.handle && item.title && item.url)
            .slice(0, 12);
          this.writeHistory(updatedHistory);
        }

        stripInjectedWishlist() {
          const nodes = this.querySelectorAll(
            '.recently-viewed__wishlist, .th_wl_col_btn, .th_wl_btn, .th_prd_wl_btn, .wc_wishlistBlock, [aria-label="Add To Wishlist"], [aria-label="Remove Wishlist"]'
          );
          nodes.forEach((node) => node.remove());
        }

        readHistory() {
          try {
            const value = JSON.parse(localStorage.getItem(this.dataset.storageKey) || '[]');
            return Array.isArray(value) ? value : [];
          } catch (error) {
            return [];
          }
        }

        writeHistory(history) {
          try {
            localStorage.setItem(this.dataset.storageKey, JSON.stringify(history));
          } catch (error) {
            return;
          }
        }

        parseMoney(value) {
          if (value == null || value === '') return 0;
          const parsed = parseFloat(String(value).replace(/[^0-9.]/g, ''));
          return Number.isFinite(parsed) ? parsed : 0;
        }

        discountPercent(item) {
          const price = Number(item.price_cents) || this.parseMoney(item.price);
          const compare = Number(item.compare_at_cents) || this.parseMoney(item.compare_at_price);
          if (!(price > 0 && compare > price)) return 0;
          return Math.round(((compare - price) / compare) * 100);
        }

        createCard(item) {
          let productUrl;
          try {
            productUrl = new URL(item.url, window.location.origin);
          } catch (error) {
            return null;
          }
          if (productUrl.origin !== window.location.origin) return null;

          const listItem = document.createElement('li');
          listItem.className = 'recently-viewed__item';

          const link = document.createElement('a');
          link.className = 'recently-viewed__link';
          link.href = productUrl.href;

          if (item.image) {
            const imageWrap = document.createElement('div');
            imageWrap.className = 'recently-viewed__image-wrap';
            const image = document.createElement('img');
            image.className = 'recently-viewed__image';
            image.src = item.image;
            image.alt = item.image_alt || item.title;
            image.loading = 'lazy';
            image.width = 540;
            image.height = 720;
            imageWrap.append(image);

            const percent = this.discountPercent(item);
            if (percent > 0) {
              const badge = document.createElement('span');
              badge.className = 'recently-viewed__badge';
              badge.textContent = `-${percent}%`;
              imageWrap.append(badge);
            }

            link.append(imageWrap);
          }

          const title = document.createElement('h3');
          title.className = 'recently-viewed__title';
          title.textContent = item.title;
          link.append(title);

          const prices = document.createElement('div');
          prices.className = 'recently-viewed__prices';
          const price = document.createElement('span');
          price.className = 'recently-viewed__price';
          price.textContent = item.price || '';
          prices.append(price);

          if (item.compare_at_price) {
            const comparePrice = document.createElement('s');
            comparePrice.className = 'recently-viewed__compare-price';
            comparePrice.textContent = item.compare_at_price;
            prices.append(comparePrice);
          }

          link.append(prices);
          listItem.append(link);

          return listItem;
        }
      }
    );
  }

  /* 即使旧版自定义元素仍在往卡片里插心形，也立刻拆掉 */
  (function () {
    var SELECTOR =
      '.recently-viewed__wishlist, .th_wl_col_btn, .th_wl_btn, .th_prd_wl_btn, .wc_wishlistBlock, [aria-label="Add To Wishlist"], [aria-label="Remove Wishlist"]';
    var cleaning = false;

    function cleanRoot(root) {
      if (!root) return;
      root.querySelectorAll(SELECTOR).forEach(function (node) {
        node.remove();
      });
    }

    function cleanAll() {
      if (cleaning) return;
      cleaning = true;
      document.querySelectorAll('recently-viewed-products').forEach(cleanRoot);
      cleaning = false;
    }

    cleanAll();
    document.addEventListener('DOMContentLoaded', cleanAll);
    window.setTimeout(cleanAll, 300);
    window.setTimeout(cleanAll, 1200);

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(cleanAll);
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
